function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9523"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (7)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45731",
    d: "M10.3 2H5.4A1.4 1.4 0 0 0 4 3.4v11.2A1.4 1.4 0 0 0 5.4 16h8.4a1.4 1.4 0 0 0 1.4-1.4V6.9z",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    transform: "translate(-2 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45732",
    d: "M13 2v4.9h4.9",
    transform: "translate(-4.7 -1)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b015c1138dc381c09a5e2551f8a5785e.svg";
export { ForwardRef as ReactComponent };